import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import { useFormattedBuyIn } from '../../../../hooks';
import type { Tournament } from '../../../../types/MTT';

import { TXTMOB_Buy_inX } from './BuyIn.messages.json';
import styles from './BuyIn.scss';

export interface BuyInProps {
  tournament: Tournament;
  className?: string;
}
const BuyIn: React.FC<BuyInProps> = ({ tournament, className = '' }) => {
  const formattedBuyIn = useFormattedBuyIn(tournament);

  return (
    <div className={classNames(styles.buyIn, className)}>
      <Translation {...TXTMOB_Buy_inX} />
      {` `}
      {formattedBuyIn}
    </div>
  );
};

export default BuyIn;
